module.exports = __webpack_public_path__ + "static/img/function3.6494dd6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/icon/function3.svg
// module id = He1s
// module chunks = 11